import styled from 'styled-components';

export const CardFormContainer = styled.form`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    width: 100%;
    /* padding-bottom: 1.5rem; */
    padding-top: 1.5rem;
`;

export const Row = styled.div`
    display: flex;
    align-items: start;
    justify-content: space-evenly;
    width: 100%;
    gap: 0.75rem;
    overflow: visible;

    .input-item {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 0.5rem;
        /* width: 160px; */

        input {
            width: 100%;
        }
    }

    .input-allWidth {
        width: 100%;
    }

    label {
        color: var(--Neutral-900, #18181b);
        font-family: 'Inter', sans-serif;
        font-size: 1rem;
        font-style: normal;
        font-weight: 600;
        line-height: 1.3rem; /* 130% */
    }

    .dropdown-container  {
        /* background-color: red; */
        
        button {
            padding: .875rem 1rem;
            border-radius: .75rem;
            color: var(--Neutral-900, #18181B);
            font-family: 'Inter', sans-serif;
            font-size: 1rem;
            font-style: normal;
            font-weight: 400;
            line-height: 1.4rem;
        }
    }

    .dropdown-container.invalid label + button{
        border: 2px solid var(--Red-400, #e11d48);
        color: red;
    }

    .radio-row {
        display: flex;
        flex-direction: column;
        gap: .5rem;
    }

    .radio-div {
        display: flex;
        flex-direction: row;
        gap: 1.5rem;
        flex-wrap: nowrap;
        align-items: center;
    }

    .radio-div.invalid {
        border: 2px solid var(--Red-400, #e11d48);
        border-radius: 0.75rem;
        padding: .5rem;
        box-sizing: border-box;
    }

    .error-span {
        color: var(--Red-400, #e11d48);
        font-size: 0.75rem;
        font-weight: 500;
        line-height: 1rem;
    }
`;

export const InputRadio = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    width: 100%;
`;

export const SpanRequired = styled.span`
    color: var(--Red-400, #e11d48);
`;
